// extracted by mini-css-extract-plugin
export default {"container":"MainLayout_container__eLDlD","sub_container":"MainLayout_sub_container__-H88G"};